import $ from 'jquery';
import 'jquery-mask-plugin';

const patterns = {
    phone: (() => {
        const getMaskByValue = (cleanValue) => {
            const digits = cleanValue.replace(/[^\d]/g, '');
            switch (true) {
                case Number(digits[0]) === 8:
                    return '0 (000) 000-00-00';
                case digits.length <= 11:
                    // here is extra null at the end to have ability to add one more symbol,
                    // because onChange isn't called when not appropriate symbol is typed
                    return '+0 (000) 000-00-000';
                case digits.length === 12:
                    return '+00 (000) 000-00-000';
                case digits.length === 13:
                    return '+000 (000) 000-00-000';
                case digits.length > 13:
                    return '+0000000000000000000000';
            }
        };
        const onChange = (cep, e, field, options) => {
            const cleanValue = field.cleanVal();
            const mask = getMaskByValue(cleanValue);
            field.mask(mask, options);
        };
        return {
            maskOptions: {
                onChange,
                onKeyPress: onChange,
            },
            getMaskByValue,
        };
    })(),
    ip: {
        getMaskByValue: () => '0ZZ.0ZZ.0ZZ.0ZZ',
        maskOptions: {
            translation: {
                Z: {
                    pattern: /[0-9]/,
                    optional: true,
                },
            },
            placeholder: '___.___.___.___',
        },
    },
    ipWithMask: {
        getMaskByValue: () => '0ZZ.0ZZ.0ZZ.0ZZ/0Z',
        maskOptions: {
            translation: {
                Z: {
                    pattern: /[0-9]/,
                    optional: true,
                },
            },
            placeholder: '___.___.___.___/__',
        },
    },
};

export const Mask = {
    patterns,
    applyMask({ element, mask, maskOptions, maskPattern }) {
        if (maskPattern) {
            const { getMaskByValue, maskOptions } = patterns[maskPattern];
            $(element).mask(getMaskByValue(element.value), maskOptions);
        } else {
            $(element).mask(mask, maskOptions);
        }
    },
    unMask: (element) => {
        $(element).unmask();
    },
    getCleanValue(element) {
        return $(element).cleanVal();
    },
    makeMaskedValue({ element, value }) {
        return element ? $(element).masked(value) : value;
    },
};
